import { AfterViewInit, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { PageNames } from '../../shared/page-names.enum';
import { ModalConfig } from '../../model/modal-config';
var FaqsModalComponent = /** @class */ (function () {
    function FaqsModalComponent(navigationService, changeDetector) {
        this.navigationService = navigationService;
        this.changeDetector = changeDetector;
        this.emitCloseFaq = new EventEmitter();
        this.emitOnBack = new EventEmitter();
        this.componentName = PageNames.FAQS_MODAL;
    }
    FaqsModalComponent.prototype.ngAfterViewInit = function () {
        this.navigationService.resetNavigation();
        this.changeDetector.detectChanges();
    };
    FaqsModalComponent.prototype.onEmitCloseFaq = function () {
        this.emitCloseFaq.emit({});
    };
    FaqsModalComponent.prototype.onBack = function () {
        this.onEmitCloseFaq();
    };
    return FaqsModalComponent;
}());
export { FaqsModalComponent };
